'use client';

import { forwardRef } from 'react';

import LoadingButton from '../loading-button/loadingButton';
import { TranslatableLoadingButtonProps } from './translatableButton.props';
import { wrapTextChildren } from './translatableButton';

/**
 * Drop-in replacement for LoadingButton that auto-wraps text children in <span>
 * for translation-extension support.
 *
 * Behaves identically to LoadingButton (spinner overlay, disabled state, etc.)
 * but string/number children are wrapped in <span> automatically.
 *
 * @example
 * <TranslatableLoadingButton loading={isSubmitting}>
 *   Save Changes
 * </TranslatableLoadingButton>
 */
const TranslatableLoadingButton = forwardRef<HTMLButtonElement, TranslatableLoadingButtonProps>(
  ({ children, ...props }, ref) => {
    return (
      <LoadingButton {...props} ref={ref}>
        {wrapTextChildren(children)}
      </LoadingButton>
    );
  }
);

TranslatableLoadingButton.displayName = 'TranslatableLoadingButton';

export default TranslatableLoadingButton;
